import React from 'react'

function Bookmarks() {
    return <>
        <div>
            <img src="/images/star.png" alt="dash icon" className='inline w-16 aspect-square mr-4' />
            <h2 className='inline text-3xl font-semibold mb-2 align-middle'>My bookmarks</h2>
        </div>
    </>
}

export default Bookmarks